import { render, staticRenderFns } from "./EscrowTransfers.vue?vue&type=template&id=66433e5b&"
import script from "./EscrowTransfers.vue?vue&type=script&lang=js&"
export * from "./EscrowTransfers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports